import React from 'react';
import { getDeviceName } from "../../../../../../Utils";

const params = [ 'spends', 'conversions', 'eCost' ];

const Row = ({ affid, country, device, days, daysData }) => {
    const daysTd = days.reduce((arr, day) => {
        console.log(day, daysData);

        params.forEach(param => {
            if(daysData[day] && daysData[day][param]) arr.push(<td key={`${day}_${param}`}>{daysData[day][param]}</td>);
            else arr.push(<td key={`${day}_${param}`}></td>);
        });

        return arr;
    }, []);

    return (
        <tr>
            <td>{affid}</td>
            <td>{country}</td>
            <td>{getDeviceName(device)}</td>
            {daysTd}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysCountryTable/components/Row/index.js